import React, { useEffect } from 'react'
import './App.css'
import Catalog from './pages/Catalog'
import Home from './pages/Home/Home'
import { Switch, Route, useHistory } from 'react-router-dom'
import Cart from './pages/Cart'
import Product from './pages/Product'
import PlaceProduct from './pages/PlaceProduct'
import { setAllProducts } from './redux/root-reducer'
import { setAuthData, setIsAuth } from './redux/auth-reducer'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toast'
import Checkout from './pages/Checkout'
import { createClient } from '@supabase/supabase-js'
import Modal from './components/Modal'
import About from './pages/About'
import Profile from './pages/Profile'
import Seller from './pages/Seller'
import Favourite from './pages/Favourite'

export const supabase = createClient(
	'https://aeodcwivcqjpvfpnkyqj.supabase.co',
	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlb2Rjd2l2Y3FqcHZmcG5reXFqIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY1MzQ4MDYxMCwiZXhwIjoxOTY5MDU2NjEwfQ.dqf1zjqNJTgjuWRBLXPTtIU64zl-U74bGobqUfwdtpo'
)

const App = (props) => {
	const history = useHistory()

	const loadProducts = async () => {
		let { data, error } = await supabase
			.from('products')
			.select('id, cost, title, images, category')

		if (data) {
			props.setAllProducts(data)
		}
	}

	useEffect(() => {
		history.listen(() => {
			window.scrollTo(0, 0)
		})

		const user = supabase.auth.user()

		if (user) {
			props.setAuthData(user)
			props.setIsAuth(true)
		}
		loadProducts()
	}, [])

	return (
        <div className="wrapper">
            <Modal />
            <ToastContainer delay={3000} position="bottom-right" />
            <Switch>
                <Route path="/catalog/:id">
                    <Catalog />
                </Route>
                <Route path="/cart">
                    <Cart />
                </Route>
                <Route path={`/item/:productId`}>
                    <Product />
                </Route>
                <Route path={`/place`}>
                    <PlaceProduct />
                </Route>
                <Route path={`/about`}>
                    <About />
                </Route>
                <Route path={`/seller`}>
                    <Seller />
                </Route>
                <Route path={`/favourites`}>
                    <Favourite />
                </Route>
                <Route path={[`/profile/:profileId`, `/profile`]}>
                    <Profile />
                </Route>
                <Route path="/checkout">
                    <Checkout />
                </Route>
                <Route path="/">
                    <Home />
                </Route>
            </Switch>
        </div>
    )
}

let mapStateToProps = (state) => {
	return {
		isAuth: state.auth.isAuth,
	}
}

export default connect(mapStateToProps, {
	setAllProducts,
	setAuthData,
	setIsAuth,
})(App)
